import { AuditReportsPage } from '@app/modules/AuditReports/AuditReportsPage'

import { getAuditReportsPath } from './paths'

export const routes = [
  {
    path: getAuditReportsPath(),
    component: AuditReportsPage,
    exact: true
  }
]
